<template>
	<div class="container">
		
		 <div class="body">
		 	<div v-html="$t('other.a501')"></div>
		 	<!-- {{$t("other.a501")}} -->
		 	
		 </div>
	</div>
</template>

<script>
	
	export default {
		
		data() {
			return {
				data:[],

			}
		},
		onLoad() {
			
				
		},
		methods: {
			backmine(){
				uni.navigateBack(-1);
			},
			htmlDecodeByRegExp (str){  
             var s = "";
             if(str.length == 0) return "";
             s = str.replace(/&amp;/g,"&");
             s = s.replace(/&lt;/g,"<");
             s = s.replace(/&gt;/g,">");
             s = s.replace(/&nbsp;/g," ");
             s = s.replace(/&#39;/g,"\'");
             s = s.replace(/&quot;/g,"\"");
             return s;  
       }
		}
	}
</script>

<style>
	.body{
		/* width: 750px;
		height: 100%; */
		padding: 20px;
		/* margin: 0 auto; */
		/* display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column; */

	}
	
	ol {
		list-style: decimal;
		padding-left: 2em;
	}
	
</style>
